import * as Icons from '@ecomm/shared-icons'
import classNames from 'classnames'
import type { TypeOf } from 'zod'

import type { listItemSchema } from './schema'

type ConfidenceItemProps = TypeOf<typeof listItemSchema>

/**
 * Will add a <br/> html tag for every occurrence of \n character in
 * input string. Final result is returned as an array of JSX span elements.
 * If there is no \n character, input is returned as is.
 */
function parseNewLinesCharacters(input?: string) {
  return input?.includes('\n')
    ? input.split('\n').map(e => (
        <span key={e}>
          {e}
          <br />
        </span>
      ))
    : input
}

function ConfidenceItem({
  icon,
  headline,
  mobileHeadline,
  body,
  disclaimer,
  showBodyInMobile = false
}: ConfidenceItemProps) {
  const Icon = Icons[icon]

  const bodyElement = parseNewLinesCharacters(body)

  return (
    <div
      className="flex w-full flex-row items-start gap-4 lg:flex-col lg:gap-0"
      data-component="ConfidenceItem"
      key={headline}
    >
      <div className="flex flex-col">
        <Icon className="text-neutral-black my-2" height={40} width={40} />
      </div>
      <div className="text-neutral-black flex flex-col">
        {headline ? (
          <>
            <h3 className="my-2 hidden text-base font-bold md:text-lg lg:block">
              {headline}
            </h3>
            <h3 className="my-2 text-base font-bold md:text-lg lg:hidden">
              {mobileHeadline ?? headline}
            </h3>
          </>
        ) : null}
        {bodyElement ? (
          <p
            className={classNames('my-2 text-lg lg:block', {
              hidden: !showBodyInMobile
            })}
          >
            {bodyElement}
          </p>
        ) : null}
        {disclaimer ? <p className="my-0 text-xs">{disclaimer}</p> : null}
      </div>
    </div>
  )
}

export default ConfidenceItem
